export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-ticket-f922b318786b71a7bfae4f9139a9a738.svg";